import { useState } from "react";

export enum WorkspaceDensity {
  Standard = "standard",
  Compact = "compact",
}

const STORAGE_KEY = "saile.providerWorkspace.density";

function readDensity(): WorkspaceDensity {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === WorkspaceDensity.Compact
      ? WorkspaceDensity.Compact
      : WorkspaceDensity.Standard;
  } catch {
    return WorkspaceDensity.Standard;
  }
}

/** The viewer's roster density, remembered in this browser. */
export function useWorkspaceDensity() {
  const [density, setDensity] = useState(readDensity);
  function changeDensity(next: WorkspaceDensity) {
    setDensity(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // The choice still applies until the page reloads.
    }
  }
  return { density, changeDensity };
}
